import { FormatterCallbackFunction } from 'highcharts';

import { BaseChart } from '@/components/Charts';

interface Series {
  name?: string;
  data: { y: number; color?: string }[];
}

interface LineChartProps {
  title: string;
  subtitle?: string;
  series: Series[];
  categories: string[];
  headerTooltip?: string;
  labelFormatter?: FormatterCallbackFunction<Highcharts.Series>;
  formatValue?: (val: number) => string | JSX.Element;
  headerStats?: { label: string; value: number }[];
}

export const LineChart = ({
  labelFormatter,
  formatValue,
  headerStats,
  ...rest
}: LineChartProps) => {
  return (
    <BaseChart
      {...rest}
      chartType="line"
      showDataLabels={false}
      formatValue={formatValue}
      headerStats={headerStats}
      customOptions={{
        legend: {
          ...(labelFormatter ? { labelFormatter } : {}),
          useHTML: true,
        },
        yAxis: {
          opposite: true,
        },
        xAxis: {
          gridLineWidth: 1,
          crosshair: {
            width: 1,
            color: '#BEB4B4',
            dashStyle: 'Solid',
          },
        },
        plotOptions: {
          series: {
            linecap: 'square',
          },
          line: {
            lineWidth: 2,
            marker: {
              enabled: false,
              symbol: 'circle',
            },
          },
        },
      }}
    />
  );
};
